var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Icon from '@ant-design/icons';
var CloseSVG = function () { return (React.createElement("svg", { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { d: 'M15.7125 16.7731L7.2272 8.28786C6.93729 7.99795 6.93729 7.51711 7.2272 7.2272C7.51712 6.93729 7.99795 6.93729 8.28786 7.2272L16.7731 15.7125C17.0631 16.0024 17.0631 16.4832 16.7731 16.7731C16.4832 17.0631 16.0024 17.0631 15.7125 16.7731Z', fill: 'currentColor' }),
    React.createElement("path", { d: 'M7.2272 16.7731C6.93729 16.4832 6.93729 16.0024 7.2272 15.7125L15.7125 7.2272C16.0024 6.93729 16.4832 6.93729 16.7731 7.2272C17.0631 7.51712 17.0631 7.99795 16.7731 8.28786L8.28786 16.7731C7.99795 17.0631 7.51711 17.0631 7.2272 16.7731Z', fill: 'currentColor' }))); };
export var CloseOutline = function (props) { return (React.createElement(Icon, __assign({ component: CloseSVG }, props))); };
//# sourceMappingURL=CloseOutline.js.map